import { Trans, useTranslation } from "react-i18next";
import style from "./style.module.scss";
import { clx } from "../../../helpers/components";
import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion';
import { FaqAccordion } from "../../pages/faq/FaqAccordion";
import { Link, useLocation, useNavigate } from "react-router-dom"
// import { BsCardList } from "react-icons/bs";

export const CheckAndHideFooter = () => {
    const notifExist = localStorage.getItem('notif')
    const ftElement = document.querySelector('#preloader');
    if (notifExist || !notifExist) {
        if (ftElement) {
            ftElement.style.height = '100%';
        }

    }
}

export function CGUSection() {
    const { t } = useTranslation("translations")
    const questions = [
        {
            title: t("general-conditions.allTerms.terms.accessibility.title"),
            description: <Accessibility />
        },
        {
            title: t("general-conditions.allTerms.clause.title"),
            description: <WarningRisck />

        },
        {
            title: t("general-conditions.allTerms.fiscality.title"),
            description: <Glosary />
        },
        {
            title: t("general-conditions.allTerms.personnalData.title"),
            description: <ServiceOffered />
        },
        {
            title: t("general-conditions.allTerms.litige.title"),
            description: <Eligibility />
        },
        {
            title: t("general-conditions.allTerms.property.title"),
            description: <AccountCreation />
        },
        {
            title: t("general-conditions.allTerms.specificRules.title"),
            description: <SpecificRules />
        },
        {
            title: t("general-conditions.allTerms.generalRules.title"),
            description: <GeneralRules />
        },
        {
            title: t("general-conditions.allTerms.userNotification.title"),
            description: <UserNotification />
        },
        {
            title: t("general-conditions.allTerms.userObligations.title"),
            description: <UserObligations />
        },
        {
            title: t("general-conditions.allTerms.companyObligations.title"),
            description: <CompanyObligations />
        },
        {
            title: t("general-conditions.allTerms.limitationAndCommunications.title"),
            description: <LimitationAndCommunications />
        },
        {
            title: t("general-conditions.allTerms.personalData.title"),
            description: <PersonalData />
        },
        {
            title: t("general-conditions.allTerms.fraudPrevention.title"),
            description: <FraudPrevention />
        },
        {
            title: t("general-conditions.allTerms.intellectualProperty.title"),
            description: <IntellectualProperty />
        },
        {
            title: t("general-conditions.allTerms.forceMajeure.title"),
            description: <ForceMajeure />
        },
        {
            title: t("general-conditions.allTerms.termsModification.title"),
            description: <TermsModification />
        },
        {
            title: t("general-conditions.allTerms.applicableLaw.title"),
            description: <ApplicableLaw />
        },
        {
            title: t("general-conditions.allTerms.specificServiceRules.title"),
            description: <SpecificServiceRules />
        },
        {
            title: t("general-conditions.allTerms.miscellaneousProvisions.title"),
            description: <MiscellaneousProvisions />
        },

    ]

    const [index, setIndex] = React.useState(null)
    const handleOpen = (i) => {
        setIndex(prev => i === prev ? null : i)
    }
    return (
        <div className={style.section}>
            <div className={style.sectionContainer}>
                {
                    questions.map((q, i) => (
                        <FaqAccordion
                            key={i}
                            title={q.title}
                            isOpen={i === index}
                            onOpen={() => handleOpen(i)}
                        >
                            {q.description}
                        </FaqAccordion>
                    ))
                }
            </div>

        </div>
    )
}

export function GeneralConditions() {
    const { t } = useTranslation("translations")
    // const [open, setOpen] = React.useState(null)
    // const [loading, setLoading] = React.useState(localStorage.getItem('isLoading') === 'true' || false)

    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }

    useEffect(() => CheckAndHideFooter(), [])
    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions}>
                        <div className={style.wrapperContent}>

                            {/* Titre + description */}
                            <div>
                                <h2>{t("general-conditions.pageTitle")}</h2>
                                <p className="mt-2rem h2z">
                                    {t("general-conditions.description")}
                                </p>
                            </div>

                            {/* Qui sommes-nous */}
                            <div className="mt-2rem">
                                <h3 className={style.titleHighlited}>{t("general-conditions.whoAreWe.title")}</h3>
                                <p className="mt-2rem">
                                    {t("general-conditions.whoAreWe.description")}
                                </p>
                            </div>

                            {/* Que faisons-nous */}
                            <div className="mt-2rem">
                                <h3 className={style.titleHighlited}>{t("general-conditions.whatDoWeDo.title")}</h3>

                                <p className="mt-2rem">
                                    {t("general-conditions.whatDoWeDo.description-1")}
                                </p>

                                <p className="mt-2rem">
                                    {t("general-conditions.whatDoWeDo.description-2")}
                                </p>

                                <ul style={ulStyle}>
                                    <li style={liStyle}>{t("general-conditions.whatDoWeDo.description-3")}</li>
                                    <li style={liStyle}>{t("general-conditions.whatDoWeDo.description-4")}</li>
                                    <li style={liStyle}>{t("general-conditions.whatDoWeDo.description-5")}</li>
                                    <li style={liStyle}>{t("general-conditions.whatDoWeDo.description-6")}</li>
                                    <li style={liStyle}>{t("general-conditions.whatDoWeDo.description-7")}</li>
                                </ul>
                            </div>

                            {/* Portée des CG */}
                            <div className="mt-2rem">
                                <h3 className={style.titleHighlited}>{t("general-conditions.termsScope.title")}</h3>

                                <p className="mt-2rem">
                                    {t("general-conditions.termsScope.description-1")}
                                </p>

                                <ul style={ulStyle}>
                                    <li style={liStyle}>{t("general-conditions.termsScope.description-2")}</li>
                                    <li style={liStyle}>{t("general-conditions.termsScope.description-3")}</li>
                                    <li style={liStyle}>{t("general-conditions.termsScope.description-4")}</li>
                                </ul>

                                <p className="mt-2rem">
                                    {t("general-conditions.termsScope.description-5")}
                                </p>
                            </div>


                            {/* Accès aux CG */}
                            <div className="mt-3rem">
                                <div className={style.listTerms}>
                                    <h5  style={{ marginBottom: 30 }}>
                                        {t("general-conditions.allTerms.title")}
                                    </h5>
                                    <CGUSection />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export function Accessibility() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.terms.accessibility.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.intro-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.intro-2")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.intro-3")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.intro-4")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">
                    <strong>{t("general-conditions.allTerms.terms.accessibility.description.list-item-1-title")}</strong>
                    {" "}{t("general-conditions.allTerms.terms.accessibility.description.list-item-1-text")}
                </p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">
                    <strong>{t("general-conditions.allTerms.terms.accessibility.description.list-item-2-title")}</strong>
                    {" "}{t("general-conditions.allTerms.terms.accessibility.description.list-item-2-text")}
                </p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">
                    <strong>{t("general-conditions.allTerms.terms.accessibility.description.list-item-3-title")}</strong>
                    {" "}{t("general-conditions.allTerms.terms.accessibility.description.list-item-3-text")}
                </p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.conclusion")}</p>
            </div>

        </div >
    )
}

export function WarningRisck() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.clause.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-2")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-3")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-4")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-5")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.intro-6")}</p>
            </div>
            <div className="mt-1rem mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.section-3-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.section-3-1-para-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.section-3-1-para-2")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={clx("mt-2rem", style.titleHighlited)}>{t("general-conditions.allTerms.clause.description.risk-1-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-1-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-2-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-2-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-3-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-3-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-4-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-4-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-5-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-5-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-6-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-6-intro")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-4")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-5")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-6")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-7")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-8")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.clause.description.risk-6-item-9")}</li>
                </ul>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-7-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-7-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-8-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-8-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-9-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-9-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-10-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-10-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.clause.description.risk-11-title")}</h6>
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description.risk-11-desc")}</p>
            </div>

        </div >
    )
}

export function ServiceOffered() {
  const { t } = useTranslation("translations")

  const bulletStyle = {
    display: "inline-block",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#0f766e", // vert Izichange
    marginRight: "8px",
    position: "relative",
    top: "-1px",
  }

  const subBulletStyle = {
    ...bulletStyle,
    width: "5px",
    height: "5px",
    marginRight: "6px",
  }

  const titleStyle = {
    fontWeight: 600, // medium
  }

  const descStyle = {
    fontWeight: 400, // normal
  }

  return (
    <div>
      {/* Intro */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          {t("general-conditions.allTerms.personnalData.description.intro")}
        </p>
      </div>

      {/* Service 1 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-1-title")}
          </span>
          {" : "}
          <span style={descStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-1-desc")}
          </span>
        </p>
      </div>

      {/* Service 2 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-2-title")}
          </span>
          {" : "}
          <span style={descStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-2-desc")}
          </span>
        </p>
      </div>

      {/* Service 3 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-3-title")}
          </span>
          {" : "}
          <span style={descStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-3-desc")}
          </span>
        </p>
      </div>

      {/* Service 4 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-4-title")}
          </span>
          {" : "}
          <span style={descStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-4-desc")}
          </span>
        </p>
      </div>

      {/* Service 5 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-5-title")}
          </span>
          {" : "}
          <span style={descStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-5-desc")}
          </span>
        </p>
      </div>

      {/* Service 6 */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          <span style={bulletStyle} />
          <span style={titleStyle}>
            {t("general-conditions.allTerms.personnalData.description.service-6-title")}
          </span>
          {" :"}
        </p>

        <div className="ml-2rem">
          <p className="mt-1rem">
            <span style={subBulletStyle} />
            <span style={titleStyle}>
              {t("general-conditions.allTerms.personnalData.description.service-6-wallet-1-title")}
            </span>
            {" : "}
            <span style={descStyle}>
              {t("general-conditions.allTerms.personnalData.description.service-6-wallet-1-desc")}
            </span>
          </p>

          <p className="mt-1rem">
            <span style={subBulletStyle} />
            <span style={titleStyle}>
              {t("general-conditions.allTerms.personnalData.description.service-6-wallet-2-title")}
            </span>
            {" : "}
            <span style={descStyle}>
              {t("general-conditions.allTerms.personnalData.description.service-6-wallet-2-desc")}
            </span>
          </p>
        </div>
      </div>

      {/* Conclusion */}
      <div className="mt-1rem">
        <p className="mt-1rem">
          {t("general-conditions.allTerms.personnalData.description.conclusion")}
        </p>
      </div>
    </div>
  )
}



export function Glosary() {
  const { t } = useTranslation("translations")

  const containerStyle = {
    marginTop: "1.5rem",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  }

  const paragraphStyle = {
    fontSize: "0.95rem",
    lineHeight: "1.7",
    margin: 0,
    paddingLeft: "1.5rem",
    position: "relative",
  }

  const bulletStyle = {
    position: "absolute",
    left: 0,
    color: "var(--izi-primary-color)",
    fontWeight: "bold",
    fontSize: "1.1rem",
  }

  const termStyle = {
    fontWeight: 600,
  }

  const TermLine = ({ termKey, descKey }) => (
    <p style={paragraphStyle}>
      <span style={bulletStyle}>●</span>
      <span style={termStyle}>{t(termKey)}</span> : {t(descKey)}
    </p>
  )

  return (
    <div>
      <div className="mt-1rem">
        <p>{t("general-conditions.allTerms.fiscality.description.intro-1")}</p>
      </div>

      <div className="mt-1rem">
        <p>{t("general-conditions.allTerms.fiscality.description.intro-2")}</p>
      </div>

      <div className="mt-1rem">
        <p>{t("general-conditions.allTerms.fiscality.description.intro-3")}</p>
      </div>

      <div style={containerStyle}>
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-1-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-1-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-2-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-2-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-3-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-3-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-4-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-4-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-5-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-5-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-6-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-6-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-7-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-7-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-8-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-8-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-9-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-9-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-10-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-10-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-11-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-11-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-12-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-12-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-13-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-13-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-14-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-14-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-15-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-15-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-16-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-16-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-17-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-17-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-18-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-18-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-19-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-19-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-20-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-20-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-21-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-21-desc"
        />
        <TermLine
          termKey="general-conditions.allTerms.fiscality.description.definition-22-term"
          descKey="general-conditions.allTerms.fiscality.description.definition-22-desc"
        />
      </div>
    </div>
  )
}


export function Eligibility() {
  const { t } = useTranslation("translations")
const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }

  return (
    <div>
      <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.litige.description.section-title")}</h5>
        <p className="mt-1rem">{t("general-conditions.allTerms.litige.description.intro")}</p>

        {/* LISTE DES CRITÈRES */}
        <ul className="mt-1rem" style={ulStyle}>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-1")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-2")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-3")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-4")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-5")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-6")}</li>
          <li style={liStyle}>{t("general-conditions.allTerms.litige.description.criteria-7")}</li>
        </ul>
      </div>

      <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.litige.description.section-2-title")}</h5>
        <p className="mt-1rem">{t("general-conditions.allTerms.litige.description.modification-text")}</p>
      </div>
    </div>
  )
}


export function Privacy() {
    const { t } = useTranslation("translations")
    const modalitiesCount = {
        total: 4,
        els: 3
    }
    return (
        <div>
            <h3>{t("general-conditions.allTerms.privacy.title").toUpperCase()}</h3>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.privacy.subtitle")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.1.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.1.description"} >
                        En conformité, d’une part, avec la réglementation en vigueur sur la protection des données à caractère personnel (ci-après les « Données ») et, d’autre part, avec notre démarche de sécurité, de confidentialité et de protection continue des Données des utilisateurs de nos services, la présente Politique a pour objet de vous fournir certaines informations, notamment celles relatives à qui nous sommes, au traitement de vos Données, ainsi que l’exercice de vos droits concernant ces Données.<br />Veuillez lire attentivement ce qui suit pour comprendre nos pratiques concernant vos données personnelles et la manière dont nous les traitons.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.2.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.2.description"} >
                        IZICHANGE fournit des Services d’Achat et de Vente de Crypto-actifs via le site internet <a href="https://izichange.com" aria-label="lien vers izichange" className="text-primary" />{{ site_lien: "https://izichange.com" }}<a /> (ci-après désignée la « Plateforme ») dont l’Éditeur est IZIGROUP, une Société à responsabilité limitée (SARL) dont le siège social est situé lot 0075 - Maison TOGONOU Mardeleine, Quartier Sodjéatimè, Boîte postale : 02 BP 348, Cotonou (République du Bénin), immatriculée au R.C.C.M. Bénin sous le numéro RC N°RCCM RB/COT/19 B 23954.
                    </Trans>
                </p>
                <div className="mt-1rem ml-1rem">
                    <h6>
                        {t("general-conditions.allTerms.privacy.description.2.description_detail_title")}
                    </h6>
                    <div className="mt-1rem">
                        <p className={clx("mt-5", style["text-lighten"])}>
                            {t("general-conditions.allTerms.privacy.description.2.description_detail_1", {
                                admin_name: "Edouard KOUGBLENOU",
                                admin_title: "+22997286954"
                            })}
                        </p>
                        <p className={clx("mt-5", style["text-lighten"])}>
                            <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.2.description_detail_2"} >
                                Adresse électronique : <a className="text-primary" href="mailto:compliance@izichange.com" aria-label="mailto:compliance@izichange.com">{{ complience_email: "compliance@izichange.com" }}</a>
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.3.title")}</h5>
                <div className="mt-1rem">
                    <p className="mb-10">
                        {t("general-conditions.allTerms.privacy.description.3.description_1")}
                    </p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.3")}
                        </li>
                    </ul>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.privacy.description.3.description_2")}

                    </p>
                </div>

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.5.title")}</h5>
                <div className="mt-1rem">
                    <p className="mb-10">
                        {t("general-conditions.allTerms.privacy.description.5.description_1")}
                    </p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.3")}
                        </li>

                    </ul>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.privacy.description.5.description_2")}

                    </p>
                    <ul>

                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.4")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.5")}
                        </li>
                    </ul>
                </div>

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.6.title")}</h5>
                {
                    Array.from(new Array(modalitiesCount.total)).map((_, i) => (
                        <table className={style.grouped} key={i}>
                            {
                                Array.from(new Array(modalitiesCount.els)).map((_, j) => (
                                    <React.Fragment key={j}>
                                        <tr>
                                            <th>{t(`general-conditions.allTerms.privacy.description.6.modalities.${i + 1}.${j + 1}.title`)}</th>
                                        </tr>
                                        <tr>
                                            <td>{t(`general-conditions.allTerms.privacy.description.6.modalities.${i + 1}.${j + 1}.description`)}</td>
                                        </tr>
                                    </React.Fragment>
                                ))

                            }
                        </table>
                    ))
                }

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.7.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.7.description_1"} >
                        Conformément aux dispositions de la Loi béninoise n° 2009-09 portant protection des données à caractère personnel et de la Loi n° 2017-20 portant code du numérique en République du Bénin (en son Livre 5ème relatif à la protection des données personnelles et de la vie privée), vos données sont collectées sur la base de votre consentement à leur traitement, lorsque ce dernier est nécessaire à l’exécution du contrat par IZICHANGE ou à l’exécution de mesures précontractuelles, sur la base d’une obligation légale ou encore d’un intérêt légitime de IZICHANGE.<br />Nous ne vous enverrons des communications de marketing direct par courrier électronique ou par SMS que si nous disposons de votre consentement.<br />Votre consentement à nous communiquer vos Données vaut également votre consentement pour partager celles-ci avec les tiers avec lesquels nous sommes susceptibles de transférer certaines de vos Données, pour les besoins du service.<br />Il s’agit notamment:
                    </Trans>
                </p>
                <ul>
                    <li>
                        {t("general-conditions.allTerms.privacy.description.7.details.1")}
                    </li>
                    <li>
                        {t("general-conditions.allTerms.privacy.description.7.details.2")}
                    </li>

                </ul>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.7.description_2")}
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.8.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.8.description"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.9.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.9.description_1"} >
                    </Trans>
                </p>
                <p className="mt-10">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.9.description_2"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.10.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.10.description"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.11.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.11.description"} >
                        Toutes les informations que vous nous fournissez sont stockées sur nos serveurs sécurisés.<br />Vous êtes responsable de la confidentialité de vos mots de passe et codes vous permettant d’accéder à votre compte et à nos services. Nous vous demandons de ne pas les partager avec qui que ce soit.<br />Nous veillerons à ce que vos données personnelles ne soient accidentellement perdues, utilisées ou consultées de manière non autorisée, notamment en utilisant des procédures et des dispositifs de sécurité stricts.<br />Nous avons mis en place des procédures pour traiter tout soupçon de violation de données personnelles. Le cas échéant, nous vous en informerons, ainsi que les autorités compétentes, en l’occurrence l’Autorité de Protection des Données à caractère Personnel (APDP).
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.12.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.12.description"} >
                        Dans certaines circonstances, vous pouvez nous demander de supprimer vos données (voir la rubrique Vos droits légaux ci-dessous pour plus d'informations).<br /><br />Dans certaines circonstances, nous rendrons vos données personnelles anonymes (afin qu'elles ne puissent plus être associées à vous) à des fins de recherche ou de statistiques, auquel cas nous pouvons utiliser ces informations indéfiniment sans vous en informer.<br /><br />Si vous n'utilisez pas l'application pendant une période de 24 mois, nous considérerons que votre compte a expiré et vos données personnelles pourront être supprimées.<br /><br />Nous conservons vos Données le temps nécessaire pour les finalités poursuivies et conformément à nos obligations en matière de lutte contre le blanchiment de capitaux et le financement du terrorisme. Dans ce dernier cas, vos données de transactions seront conservées pendant une période de cinq ans suivant la clôture de votre compte et la fin de nos relations contractuelles.<br /><br />Quant aux enregistrements des communications téléphoniques, ils seront conservés pendant une période maximum de 60 jours à compter de l’enregistrement.<br /><br />Vos Données peuvent être conservées au-delà de la durée nécessaire en vue d'être traitées à des fins historiques, statistiques ou scientifiques.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.13.title")}</h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_1")}
                </p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.1.title")}</p>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_2")}
                </p>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_3")}
                </p>
                <div className="ml-10">
                    <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.2.title")}</p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.3")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.3")}
                        </li>

                    </ul>
                </div>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.3.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.4.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.5.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.6.title")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.14.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_1"} >
                        Vous pouvez exercer vos droits (voir la rubrique Vos droits légaux ci-dessus pour plus d'informations) en adressant une demande à notre Responsable du traitement aux adresses mentionnées ci-dessus (Voir rubrique Coordonnées). Toutefois, notre Responsable du traitement a le droit de s’opposer aux demandes manifestement abusives, notamment par leur nombre, leur caractère répétitif ou systématique.<br /><br />Toute personne demandant à exercer un droit doit justifier de son identité. Nous nous efforçons de traiter votre demande dans un délai raisonnable à compter de sa réception. A cette fin, nous sommes susceptibles de vous demander des informations ou des documents complémentaires.<br /><br />Une copie des Données traitées vous concernant vous est délivrée à votre demande. Toutefois, cette délivrance peut être subordonnée au paiement d’une somme correspondant au coût de la reproduction.
                    </Trans>
                </p>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_2"} >
                    </Trans>
                </p>
                <p className="mt-10 flex">
                    <span className="mr-10">-</span>
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_3"} >
                        si vous avez des raisons sérieuses de penser qu’il y a un risque de dissimulation ou de disparition de vos Données, pour que l’APDP prenne toute mesure de nature à éviter cette dissimulation ou cette disparition ; - si vous avez des raisons sérieuses d’admettre que les données qui vous ont été communiquées ne sont pas conformes aux données traitées, pour que l’APDP procède aux vérifications nécessaires. Vous avez le droit d’introduire toute réclamation devant l’APDP à l’adresse suivante : Rue 6.076 « Immeuble El Marzouk Joël » COTONOU, Tél. : {{ tel: "+229 21 32 57 88" }} ; Email :{{ email: " contact@apdp.bj" }}.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.15.title")}</h5>
                <ul>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.1"} >
                            <b>Le consenment</b> désigne votre accord pour le traitement de vos données personnelles, signifié par une déclaration ou une acceptation claire du traitement dans un but spécifique. Le consentement ne sera valable que s'il s'agit d'une indication libre, spécifique, expresse et sans ambiguïté de ce que vous voulez. Vous pouvez retirer votre consentement à tout moment en nous contactant.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.2"} >
                            <b>L'intérêt légitime</b> signifie l'intérêt de notre entreprise dans la conduite et la gestion de nos activités en vue de vous offrir le meilleur service/produit et l'expérience la meilleure et la plus sûre. Nous nous assurons de considérer et d'équilibrer tout impact potentiel sur vous (à la fois positif et négatif) et vos droits avant de traiter vos données personnelles pour nos intérêts légitimes. Nous n'utilisons pas vos données personnelles pour des activités dont l'impact sur vous l'emporte sur nos intérêts (sauf si nous avons votre consentement ou si la loi nous y oblige ou nous y autorise). Vous pouvez obtenir de plus amples informations sur la manière dont nous évaluons nos intérêts légitimes par rapport à tout impact potentiel sur vous dans le cadre d'activités spécifiques en nous contactant.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.3"} >
                            <b>Exécution du contrat</b> désigne la mise en œuvre du contrat dont certaines parties peuvent nécessiter le traitement de vos données ou celle des mesures prises à votre demande avant la conclusion du contrat.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.4"} >
                            <b>Respecter une obligation légale</b> signifie le fait pour nous de nous conformer à une disposition législative ou réglementaire encadrant le traitement de vos données personnelles.
                        </Trans>
                    </li>

                </ul>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.16.title")}</h5>
                <ul>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.1"} >
                            <b>Données d'identité </b>: prénom, nom, nom de jeune fille, nom d'utilisateur ou identifiant similaire, date et lieu de naissance.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.2"} >
                            <b>Données de contact </b>: adresse électronique (ou e-mail) et numéros de téléphone
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.3"} >
                            <b>Données financières </b>: adresse cryptographique du Compte Crypto
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.4"} >
                            <b>Données de transaction </b>: comprend les détails des paiements à destination et/ou en provenance de vous et les détails des Achats et des Ventes réalisées.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.5"} >
                            <b>Données relatives à l'appareil </b>: comprend le type d'appareil mobile que vous utilisez.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.6"} >
                            <b>Données de profil</b> : comprennent votre nom utilisateur, votre adresse électronique (ou e-mail) et votre mot de passe, l'historique de vos achats dans l'application, vos intérêts, vos préférences, vos commentaires et vos réponses aux enquêtes.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.7"} >
                            <b>Données d'utilisation </b>: comprennent les détails de votre utilisation de notre Plateforme, y compris, mais sans s'y limiter, les données de trafic
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.8"} >
                            <b>Données de marketing et de communication </b>: comprennent vos préférences en matière de réception de marketing de notre part et de celle de nos tiers, ainsi que vos préférences en matière de communication.
                        </Trans>
                    </li>
                </ul>
            </div>
        </div >
    )
}

export function SpecificRules() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.specificRules.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.specificRules.details.1.title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.1.description")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.specificRules.details.2.title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.2.description-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.2.description-2")}</p>
            </div>
        </div>
    )
}

export function GeneralRules() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.generalRules.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.generalRules.details.1.title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.generalRules.details.1.description-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.generalRules.details.1.description-2")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.1.item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.1.item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.1.item-3")}</li>
                </ul>
                <p className="mt-1rem">{t("general-conditions.allTerms.generalRules.details.1.description-3")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.generalRules.details.1.description-4")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.generalRules.details.2.title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.generalRules.details.2.description")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-4")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-5")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-6")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.2.item-7")}</li>
                </ul>
            </div>
        </div>
    )
}

export function UserNotification() {
    const { t } = useTranslation("translations")
    return (
        <div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userNotification.section-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userNotification.section-1-desc")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userNotification.section-2-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userNotification.section-2-desc")}</p>
            </div>
        </div>
    )
}

export function UserObligations() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-1-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-2-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-2-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-3-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-3-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-4-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-4-intro")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.userObligations.section-4-item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.userObligations.section-4-item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.userObligations.section-4-item-3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.userObligations.section-4-item-4")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.userObligations.section-4-item-5")}</li>
                </ul>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-5-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-5-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-6-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-6-desc")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.userObligations.section-7-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.userObligations.section-7-desc")}</p>
            </div>
        </div>
    )
}

export function CompanyObligations() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            <p className="mt-1rem">{t("general-conditions.allTerms.companyObligations.intro")}</p>
            <ul className="mt-1rem" style={ulStyle}>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-1")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-2")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-3")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-4")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-5")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-6")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-7")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-8")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.companyObligations.item-9")}</li>
            </ul>
            <p className="mt-1rem">{t("general-conditions.allTerms.companyObligations.conclusion")}</p>
        </div>
    )
}

export function LimitationAndCommunications() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.limitationAndCommunications.section-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-1-desc")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.limitationAndCommunications.section-2-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-2-intro")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-2-para-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-2-para-2")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-2-para-3")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.limitationAndCommunications.section-2-para-4")}</p>
            </div>
        </div>
    )
}

export function PersonalData() {
    const { t } = useTranslation("translations")
    return (
        <div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.intro-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.intro-2")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.intro-3")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.intro-4")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.rights")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.retention")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.dispute")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.personalData.policy-link")}</p>
            </div>
        </div>
    )
}

export function FraudPrevention() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.fraudPrevention.intro")}</p>
            </div>
            <ul className="mt-1rem" style={ulStyle}>
                <li style={liStyle}>{t("general-conditions.allTerms.fraudPrevention.item-1")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.fraudPrevention.item-2")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.fraudPrevention.item-3")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.fraudPrevention.item-4")}</li>
            </ul>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.fraudPrevention.conclusion")}</p>
            </div>
        </div>
    )
}

export function IntellectualProperty() {
    const { t } = useTranslation("translations")
    return (
        <div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.intellectualProperty.intro")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.intellectualProperty.para-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.intellectualProperty.para-2")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.intellectualProperty.para-3")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.intellectualProperty.para-4")}</p>
            </div>
        </div>
    )
}

export function ForceMajeure() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.forceMajeure.intro")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.forceMajeure.list-intro")}</p>
            </div>
            <ul className="mt-1rem" style={ulStyle}>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-1")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-2")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-3")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-4")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-5")}</li>
                <li style={liStyle}>{t("general-conditions.allTerms.forceMajeure.item-6")}</li>
            </ul>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.forceMajeure.para-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.forceMajeure.para-2")}</p>
            </div>
        </div>
    )
}

export function TermsModification() {
    const { t } = useTranslation("translations")
    const paras = t("general-conditions.allTerms.termsModification.paras", { returnObjects: true })
    const list = Array.isArray(paras) ? paras : []
    return (
        <div>
            <div className="mt-1rem">
                {list.map((p, i) => (
                    <p className="mt-1rem" key={i}>{p}</p>
                ))}
            </div>
        </div>
    )
}

export function ApplicableLaw() {
    const { t } = useTranslation("translations")
    return (
        <div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.applicableLaw.para-1")}</p>
            </div>
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.applicableLaw.para-2")}</p>
            </div>
        </div>
    )
}

export function SpecificServiceRules() {
    const { t } = useTranslation("translations")
    const blocks = t("general-conditions.allTerms.specificServiceRules.blocks", { returnObjects: true })
    const list = Array.isArray(blocks) ? blocks : []
    return (
        <div>
            {list.map((block, i) => (
                <div className="mt-2rem" key={i}>
                    <h5 className={style.titleHighlited}>{block.title}</h5>
                    {(block.paras || []).map((p, j) => (
                        <p className="mt-1rem" key={j}>{p}</p>
                    ))}
                    {(block.subs || []).map((sub, k) => (
                        <div className="mt-1rem" key={k}>
                            <h6 className={style.titleHighlited}>{sub.title}</h6>
                            {(sub.paras || []).map((p, m) => (
                                <p className="mt-1rem" key={m}>{p}</p>
                            ))}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export function MiscellaneousProvisions() {
    const { t } = useTranslation("translations")
    return (
        <div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.miscellaneousProvisions.section-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.miscellaneousProvisions.section-1-content")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.miscellaneousProvisions.section-2-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.miscellaneousProvisions.section-2-content")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.miscellaneousProvisions.section-3-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.miscellaneousProvisions.section-3-content")}</p>
            </div>
        </div>
    )
}

export function AccountCreation() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: "0.5rem",
        width: "100%",
    }
    const liStyle = {
        fontSize: "0.87rem",
        width: "100%",
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.property.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.intro")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-1-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-1-intro")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-1-para-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-1-para-2")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-2-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-2-para-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-2-para-2")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-2-para-3")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-2-para-4")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-3-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-3-intro")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-3-item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-3-item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-3-item-3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-3-item-4")}</li>
                </ul>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-3-para-1")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-3-para-2")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-3-para-3")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-3-para-4")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-4-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-4-intro")}</p>
                <h6 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-4-subtitle")}</h6>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-4-item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-4-item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-4-item-3")}</li>
                </ul>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-4-para")}</p>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-4-para-2")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-5-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-5-intro")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-5-item-1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-5-item-2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-5-item-3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.property.description.section-5-item-4")}</li>
                </ul>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-5-para")}</p>
            </div>
            <div className="mt-2rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.property.description.section-6-title")}</h5>
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description.section-6-para")}</p>
            </div>
        </div >
    )
}


export function Lexique() {
    const { t } = useTranslation("translations")

    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{ padding: '1rem' }}>
                        <h3>{t("lexique.title")}</h3>
                        <Glosary />
                    </div>
                </div>
            </section>
        </>
    )
}

// Politique de confidentialite page, loading the content from Termly's hosted version based on the website's UUID, with a fallback link if loading fails or is blocked by browser policies.
export function PolitiqueConf() {
    const { t, i18n } = useTranslation("translations")
    useEffect(() => CheckAndHideFooter(), [])

    const TERMLY_WEBSITE_UUID = "509d45cf-19cc-4c29-8183-2dd72af1222f"
    const [termlyPrivacyPolicyUrl, setTermlyPrivacyPolicyUrl] = useState("")
    const [isLoadingPolicy, setIsLoadingPolicy] = useState(true)
    const termlyLang = (i18n.resolvedLanguage || i18n.language || "fr").toLowerCase().startsWith("fr") ? "fr" : "en"

    useEffect(() => {
        let cancelled = false

        const loadPrivacyPolicy = async () => {
            try {
                const response = await fetch(`https://app.termly.io/api/v1/snippets/websites/${TERMLY_WEBSITE_UUID}`)
                if (cancelled) return
                const payload = await response.json()

                const privacyDocument = (payload.documents || []).find((doc) =>
                    doc.template_type === "Privacy"
                    || doc.name?.toLowerCase().includes("privacy")
                    || doc.name?.toLowerCase().includes("confidential")
                )

                if (!cancelled && privacyDocument?.uuid) {
                    setTermlyPrivacyPolicyUrl(`https://app.termly.io/policy-viewer/policy.html?policyUUID=${privacyDocument.uuid}&lang=${termlyLang}`)
                }
            } catch {
                if (!cancelled) setTermlyPrivacyPolicyUrl("")
            } finally {
                if (!cancelled) setIsLoadingPolicy(false)
            }
        }

        loadPrivacyPolicy()
        return () => { cancelled = true }
    }, [termlyLang])

    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{ padding: '1rem' }}>
                        <h2>{t("politique-conf.termly-policy.page-title")}</h2>
                        <p className="mt-1rem">
                            {t("politique-conf.termly-policy.intro")}
                        </p>

                        {isLoadingPolicy && <p className="mt-2rem">{t("politique-conf.termly-policy.loading")}</p>}

                        {!isLoadingPolicy && termlyPrivacyPolicyUrl && (
                            <>
                                <div className="mt-2rem" style={{ border: '1px solid #e6e6e6', borderRadius: '0.75rem', overflow: 'hidden' }}>
                                    <iframe
                                        title={t("politique-conf.termly-policy.page-title")}
                                        src={termlyPrivacyPolicyUrl}
                                        style={{ width: '100%', minHeight: '85vh', border: '0' }}
                                        loading="lazy"
                                    />
                                </div>

                                <p className="mt-1rem">
                                    {t("politique-conf.termly-policy.fallback-text")}{' '}
                                    <a href={termlyPrivacyPolicyUrl} target="_blank" rel="noreferrer" className="text-primary">
                                        {termlyPrivacyPolicyUrl}
                                    </a>
                                </p>
                            </>
                        )}

                        {!isLoadingPolicy && !termlyPrivacyPolicyUrl && (
                            <p className="mt-2rem">
                                {t("politique-conf.termly-policy.fallback-error")}{' '}
                                <a
                                    href="https://app.termly.io/policy-viewer/policy.html"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-primary"
                                >
                                    https://app.termly.io/policy-viewer/policy.html
                                </a>
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

function PolitiqueConfLegacy() {
    const { t } = useTranslation("translations")
    // const [loading, setLoading] = React.useState(localStorage.getItem('isLoading') === 'true' || false)

    useEffect(() => CheckAndHideFooter(), [])
    
    // Title style with left green accent
    const titleHighlitedStyle = {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '1rem',
        borderLeft: '5px solid var(--izi-primary-color)',
        fontSize: '1.1rem',
        marginTop: 10,
    };

    // List styles
    const ulStyle = {
        display: "block",
        marginTop: '1rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }

    const tableStyle = {
        border: '1px solid black',
    };

    const rowStyle = {
        border: '1px solid black',
    };

    const cellStyle = {
        border: '1px solid black',
        padding: '1rem'
    };

    const titleStyle = {
        color: "#000",
        fontWeight: 'bold'
    };

    const subtitleStyle = {
        color: "#000",
        fontWeight: 'bold',
        fontSize: 15
    }


    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} id="cond">

                        <div className={style.app}>
                            {/* {
                                isHidden && (
                                    <motion.nav
                                        className={`${style.sidebar} ${isHidden ? style.hidden : ''}`}
                                        initial={{ x: -200 }}
                                        animate={{ x: 0 }} 
                                        transition={{ type: 'spring', stiffness: 100 }}
                                    >
                                        <div onClick={() => scrollToSection('section1')}>{t('politique-conf.sommary.sommary-1')}</div>
                                        <div onClick={() => scrollToSection('section2')}>{t('politique-conf.sommary.sommary-2')}</div>
                                        <div onClick={() => scrollToSection('section3')}>{t('politique-conf.sommary.sommary-3')}</div>
                                        <div onClick={() => scrollToSection('section4')}>{t('politique-conf.sommary.sommary-4')}</div>
        
                                        <div onClick={() => scrollToSection('section5')}>{t('politique-conf.sommary.sommary-5')}</div>
                                        <div onClick={() => scrollToSection('section6')}>{t('politique-conf.sommary.sommary-6')}</div>
                                        <div onClick={() => scrollToSection('section7')}>{t('politique-conf.sommary.sommary-7')}</div>
                                        <div onClick={() => scrollToSection('section8')}>{t('politique-conf.sommary.sommary-8')}</div>
        
                                        <div onClick={() => scrollToSection('section9')}>{t('politique-conf.sommary.sommary-9')}</div>
                                        <div onClick={() => scrollToSection('section10')}>{t('politique-conf.sommary.sommary-10')}</div>
                                    </motion.nav>
                                )
                            } */}


                            {/* <nav className={style.sidebar}> */}
                            {/* <ul> */}
                            {/* <div onClick={() => scrollToSection('section1')}>{t('politique-conf.sommary.sommary-1')}</div>
                                <div onClick={() => scrollToSection('section2')}>{t('politique-conf.sommary.sommary-2')}</div>
                                <div onClick={() => scrollToSection('section3')}>{t('politique-conf.sommary.sommary-3')}</div>
                                <div onClick={() => scrollToSection('section4')}>{t('politique-conf.sommary.sommary-4')}</div>
        
                                <div onClick={() => scrollToSection('section5')}>{t('politique-conf.sommary.sommary-5')}</div>
                                <div onClick={() => scrollToSection('section6')}>{t('politique-conf.sommary.sommary-6')}</div>
                                <div onClick={() => scrollToSection('section7')}>{t('politique-conf.sommary.sommary-7')}</div>
                                <div onClick={() => scrollToSection('section8')}>{t('politique-conf.sommary.sommary-8')}</div>
        
                                <div onClick={() => scrollToSection('section9')}>{t('politique-conf.sommary.sommary-9')}</div>
                                <div onClick={() => scrollToSection('section10')}>{t('politique-conf.sommary.sommary-10')}</div> */}


                            {/* </ul> */}
                            {/* </nav> */}
                            <motion.main
                                className={style.content}
                            // initial={{ x: 200 }} 
                            // animate={{ x: 0 }} 
                            // transition={{ type: 'spring', stiffness: 100 }}
                            >
                                <div className={style.display}>
                                    {/* <BsCardList style={{ fontSize: '1.5rem'}} onClick={() => {
                                        handleIcon();
                                    }}/> */}
                                </div>
                                <div className={style.wrapperContent}>

                                    <MentionLegales />
                                    <div className={style.container_content}>
                                        <section id="section1" className={style.section}>
                                            <h2 className={style.titleHighlited} style={{ marginTop: 10, fontSize: "1.1rem" }}>
                                                {t("politique-conf.sommary.sommary-1")}
                                            </h2>

                                            <div className="mt-4 leading-relaxed text-[15px]">
                                                {/* Intro */}
                                                <p className="mb-4">{t("politique-conf.description1.description-1")}</p> <br />

                                                {/* Applies title */}
                                                <p className="mb-2 font-semibold">
                                                    {t("politique-conf.description1.description-2")}
                                                </p>

                                                {/* Applies list */}
                                                <ul style={ulStyle} className="list-disc pl-8 mb-4 space-y-2">
                                                    <li style={liStyle}>{t("politique-conf.description1.description-3")}</li> <br />
                                                    <li style={liStyle}>{t("politique-conf.description1.description-4")}</li><br />
                                                    <li style={liStyle}>{t("politique-conf.description1.description-5")}</li><br />
                                                    <li style={liStyle}>{t("politique-conf.description1.description-6")}</li><br />
                                                    <li style={liStyle}>{t("politique-conf.description1.description-7")}</li><br />
                                                </ul>

                                                {/* Notice + non acceptance */}
                                                <p className="mb-2">{t("politique-conf.description1.description-8")}</p>
                                                <p className="mb-4">{t("politique-conf.description1.description-9")}</p>

                                                {/* Contact DPO */}
                                                <p className="mb-6">
                                                    {t("politique-conf.description1.description-10")}{" "}
                                                    <a
                                                        href="mailto:compliance@izichange.com"
                                                        style={{ color: '#008080' }}
                                                        aria-label="mailto:compliance@izichange.com"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        compliance@izichange.com
                                                    </a>
                                                </p> <br />

                                                {/* Legal block */}
                                                <div className="mb-6 pl-4 border-l-4 border-gray-200">
                                                    <span className="font-bold mb-2">
                                                        {t("politique-conf.description1.description-11")}
                                                    </span>
                                                    <p className="mb-3">{t("politique-conf.description1.description-12")}</p> <br />
                                                    <p>{t("politique-conf.description1.description-13")}</p>
                                                </div> <br />

                                                {/* Objectives block */}
                                                <div className="pl-4 border-l-4 border-gray-200">
                                                    <p className="font-bold mb-2">
                                                        {t("politique-conf.description1.description-14")}
                                                    </p>
                                                    <p className="mb-2">{t("politique-conf.description1.description-15")}</p> <br />

                                                    <ul className="list-disc pl-8 space-y-2">
                                                        <li>{t("politique-conf.description1.description-16")}</li> <br />
                                                        <li>{t("politique-conf.description1.description-17")}</li><br />
                                                        <li>{t("politique-conf.description1.description-18")}</li><br />
                                                    </ul>
                                                </div>
                                            </div>
                                        </section>



                                        <section id="section2" className={style.section}>
                                            <h2 className={style.titleHighlited} style={{ marginTop: 10, fontSize: '1.1rem' }}>1- {t('politique-conf.sommary.sommary-2')}</h2>
                                            <p>{t('politique-conf.description2.description-1')}<br /><br />
                                                1. {t('politique-conf.description2.description-2')}<br /><br />
                                                2. {t('politique-conf.description2.description-3')}<br /><br />
                                                3. {t('politique-conf.description2.description-4')}<br /><br />
                                                4. {t('politique-conf.description2.description-5')}<br /><br />
                                                5. {t('politique-conf.description2.description-6')}<br /><br />
                                                6. {t('politique-conf.description2.description-7')}<br /><br />
                                                7. {t('politique-conf.description2.description-8')}<br /><br />
                                                8. {t('politique-conf.description2.description-9')}
                                            </p>
                                        </section>

                                        <section id="section3" className={style.section}>
                                            {/* Titre principal */}
                                            <h2 className={style.titleHighlited} style={{ marginTop: 10, fontSize: "1.1rem" }}>
                                                2- {t("politique-conf.sommary.sommary-5")}
                                            </h2>

                                            <div className="mt-4 leading-relaxed text-[15px]">
                                                {/* A - Fournies par vous */}
                                                <p className="font-semibold mb-2">
                                                    {t("politique-conf.description3.description-2")}
                                                </p>

                                                <p className="mb-6">
                                                    {t("politique-conf.description3.description-3")}
                                                </p>

                                                {/* TABLEAU 1 */}
                                                <div className="mb-8 overflow-x-auto">
                                                    <table style={tableStyle}>
                                                        <thead>
                                                            <tr className="_table_header" style={rowStyle}>
                                                                <th>{t("politique-conf.description3.description-4")}</th>
                                                                <th>{t("politique-conf.description3.description-5")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-6")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-7")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-8")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-9")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-10")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-11")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-12")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-13")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-14")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-15")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-16")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-17")}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Automatiquement */}
                                                <p className="font-semibold mb-2">
                                                    {t("politique-conf.description3.description-18")}
                                                </p>

                                                <p className="mb-3">
                                                    {t("politique-conf.description3.description-19")}
                                                </p>

                                                <p className="mb-6">
                                                    {t("politique-conf.description3.description-20")}
                                                </p>

                                                {/* TABLEAU 2 */}
                                                <div className="mb-6 overflow-x-auto">
                                                    <table style={tableStyle}>
                                                        <thead>
                                                            <tr className="_table_header" style={rowStyle}>
                                                                <th>{t("politique-conf.description3.description-21")}</th>
                                                                <th>{t("politique-conf.description3.description-22")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-23")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-24")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-25")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-26")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-27")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-28")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-29")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-30")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-31")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-32")}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <p className="mb-8">
                                                    {t("politique-conf.description3.description-33")}
                                                </p>

                                                {/* B - Sensibles */}
                                                <p className="font-semibold mb-2">
                                                    {t("politique-conf.description3.description-34")}
                                                </p>

                                                <p className="mb-6">
                                                    {t("politique-conf.description3.description-35")}
                                                </p>

                                                {/* TABLEAU 3 */}
                                                <div className="mb-6 overflow-x-auto">
                                                    <table style={tableStyle}>
                                                        <thead>
                                                            <tr className="_table_header" style={rowStyle}>
                                                                <th>{t("politique-conf.description3.description-36")}</th>
                                                                <th>{t("politique-conf.description3.description-37")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-38")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-39")}</p>
                                                                </td>
                                                            </tr>

                                                            <tr style={rowStyle}>
                                                                <td style={cellStyle}>
                                                                    <p style={titleStyle}>{t("politique-conf.description3.description-40")}</p>
                                                                </td>
                                                                <td style={cellStyle}>
                                                                    <p>{t("politique-conf.description3.description-41")}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <p className="mb-6">
                                                    {t("politique-conf.description3.description-42")}
                                                </p>

                                                <p className="mb-4">
                                                    {t("politique-conf.description3.description-43")}
                                                </p>

                                                <p>
                                                    {t("politique-conf.description3.description-44")}
                                                </p>
                                            </div>
                                        </section>

                                        <section id="section4" className={style.section}>
                                            <h2 className={style.titleHighlited} style={{ marginTop: 10, fontSize: "1.1rem" }}>
                                                3- {t("politique-conf.description4.description-1")}
                                            </h2>

                                            <div className="mt-4 text-[15px] leading-relaxed">
                                                <p className="mb-4">
                                                    {t("politique-conf.description4.description-2")}
                                                </p>

                                                <p className="mb-4">
                                                    {t("politique-conf.description4.description-3")}
                                                </p>

                                                <p className="mb-6">
                                                    {t("politique-conf.description4.description-4")}
                                                </p>

                                                {/* Finalités listées */}
                                                <ul className="space-y-5">
                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-5-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-5-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-6-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-6-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-7-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-7-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-8-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-8-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-9-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-9-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-10-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-10-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-11-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-11-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-12-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-12-text")}
                                                        </p>
                                                    </li> <br />

                                                    <li>
                                                        <p className="font-semibold">
                                                            {t("politique-conf.description4.description-13-title")}
                                                        </p>
                                                        <p>
                                                            {t("politique-conf.description4.description-13-text")}
                                                        </p>
                                                    </li> <br />
                                                </ul>
                                            </div>
                                        </section>

                                        <section id="section5" className={style.section}>
                                            <h2 className={style.titleHighlited} style={{ marginTop: 10, fontSize: "1.1rem" }}>
                                                4- {t('politique-conf.description5.description-1')}
                                            </h2>

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description5.description-2')}
                                            </p> <br />

                                            <span className="mt-6 font-semibold">
                                                A- {t('politique-conf.description5.description-3-title')}
                                            </span>

<ul style={ulStyle} className="list-disc pl-6 mt-2 space-y-1 text-sm">
                                                <li style={liStyle}>{t('politique-conf.description5.description-3-item-1')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-3-item-2')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-3-item-3')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-3-item-4')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-3-item-5')}</li> <br />
                                            </ul>

                                            <p className="mt-3 text-sm italic">
                                                {t('politique-conf.description5.description-4')}
                                            </p> <br />

                                            <span className="mt-6 font-semibold">
                                                B- {t('politique-conf.description5.description-5-title')}
                                            </span>

                                            <ul style={ulStyle} className="list-disc pl-6 mt-2 space-y-1 text-sm">
                                                <li style={liStyle}>{t('politique-conf.description5.description-5-item-1')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-5-item-2')}</li> <br />
                                            </ul> <br />

                                            <span className="mt-6 font-semibold">
                                                C- {t('politique-conf.description5.description-6-title')}
                                            </span>

                                            <ul style={ulStyle} className="list-disc pl-6 mt-2 space-y-1 text-sm">
                                                <li style={liStyle}>{t('politique-conf.description5.description-6-item-1')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-6-item-2')}</li> <br />
                                            </ul> <br />

                                            <span className="mt-6 font-semibold">
                                                D- {t('politique-conf.description5.description-7-title')}
                                            </span>

                                            <ul style={ulStyle} className="list-disc pl-6 mt-2 space-y-1 text-sm">
                                                <li style={liStyle}>{t('politique-conf.description5.description-7-item-1')}</li> <br />
                                                <li style={liStyle}>{t('politique-conf.description5.description-7-item-2')}</li> <br />
                                            </ul>
                                        </section>



                                        <section id="section6" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                5- {t('politique-conf.description6.description-1')}
                                            </h2>

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description6.description-2')}
                                            </p> <br />

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description6.description-3')}
                                            </p>

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description6.description-4')}
                                            </p><br />

                                            <p className="mt-4 text-sm font-medium">
                                                {t('politique-conf.description6.description-5')}
                                            </p>

<ul style={ulStyle} className="list-disc pl-6 mt-2 space-y-1 text-sm">
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-1')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-2')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-3')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-4')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-5')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-6')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-7')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-8')}</li><br />
                                                <li style={liStyle}>{t('politique-conf.description6.description-6-item-9')}</li><br />
                                            </ul>

                                            <p className="mt-4 text-sm leading-relaxed">
                                                {t('politique-conf.description6.description-7')}
                                            </p>
                                        </section>

                                        <section id="section7" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                6- {t('politique-conf.description7.description-1')}
                                            </h2>

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description7.description-2')}
                                            </p> <br />

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description7.description-3')}
                                            </p> <br />

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description7.description-4')}
                                            </p> <br />

                                            <p className="mt-4 text-sm leading-relaxed">
                                                {t('politique-conf.description7.description-5')}{' '}
                                                <a
                                                    href="https://home.izichange.com/cookies"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#008080' }}
                                                >
                                                    {t('politique-conf.description7.description-6')}
                                                </a>
                                            </p>
                                        </section>

                                        <section id="section8" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                7- {t('politique-conf.description8.description-1')}
                                            </h2>

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description8.description-2')}
                                            </p> <br />

                                            <p className="mt-3 text-sm leading-relaxed">
                                                {t('politique-conf.description8.description-3')}
                                            </p> <br />

                                            <p className="mt-4 text-sm font-medium">
                                                {t('politique-conf.description8.description-4')}
                                            </p>

<ul style={ulStyle} className="list-disc pl-6 mt-2 text-sm">
                                                <li style={liStyle}>
                                                    <strong>{t('politique-conf.description8.description-5-item-1-title')}</strong>{' '}
                                                    {t('politique-conf.description8.description-5-item-1-text')}
                                                </li>
                                                <br />
                                                <li style={liStyle}>
                                                    <strong>{t('politique-conf.description8.description-5-item-2-title')}</strong>{' '}
                                                    {t('politique-conf.description8.description-5-item-2-text')}
                                                </li>
                                                <br />
                                                <li style={liStyle}>
                                                    <strong>{t('politique-conf.description8.description-5-item-3-title')}</strong>{' '}
                                                    {t('politique-conf.description8.description-5-item-3-text')}
                                                </li>
                                                <br />
                                            </ul>

                                            <p className="mt-4 text-sm leading-relaxed">
                                                {t('politique-conf.description8.description-6')}
                                            </p>
                                        </section>


                                        {/* SECTION 9 : 8- Durée de conservation */}
                                        <section id="section9" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                8- Durée de conservation de vos informations
                                            </h2>
                                            <p>
                                                {t("politique-conf.description9.description-1")}
                                                <br /><br />
                                                {t("politique-conf.description9.description-2")}
                                                <br /><br />
                                                {t("politique-conf.description9.description-3")}
                                            </p>
                                        </section>

                                        {/* SECTION 10 : 9- Sécurité */}
                                        <section id="section10" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                9- Sécurité de vos informations
                                            </h2>
                                            <p>
                                                {t("politique-conf.description10.description-1")}
                                                <br /><br />
                                                {t("politique-conf.description10.description-2")}
                                                <br /><br />
                                                {t("politique-conf.description10.description-3")}
                                            </p>
                                        </section>

                                        {/* SECTION 11 : 10- Mineurs */}
                                        <section id="section11" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                10- Collecte d’informations auprès de mineurs
                                            </h2>
                                            <p>{t("politique-conf.description11.description-1")}</p>
                                        </section>

                                        {/* SECTION 12 : 11- Droits */}
                                        <section id="section12" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                11- Droits des personnes concernées
                                            </h2>

                                            <p>
                                                {t("politique-conf.description12.description-1")}
                                                <br /><br />
                                            </p>

<ul style={ulStyle}>
                                                <li style={liStyle}>{t("politique-conf.description12.description-2")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-3")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-4")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-5")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-6")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-7")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-8")}</li><br />
                                                <li style={liStyle}>{t("politique-conf.description12.description-9")}</li><br />
                                            </ul>

                                            <p>
                                                {t("politique-conf.description12.description-10")}{" "}
                                                <a
                                                    href="mailto:compliance@izichange.com"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ color: "#008080" }}
                                                >
                                                    compliance@izichange.com
                                                </a>
                                                .
                                                <br /><br />
                                                {t("politique-conf.description12.description-11")}
                                                <br /><br />
                                                {t("politique-conf.description12.description-12")}{" "}
                                                <a
                                                    href="mailto:contact@apdp.bj"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ color: "#008080" }}
                                                >
                                                    contact@apdp.bj
                                                </a>
                                            </p>
                                        </section>

                                        {/* SECTION 13 : 12- Mises à jour */}
                                        <section id="section13" className={style.section}>
                                            <h2 style={titleHighlitedStyle}>
                                                12- Mises à jour de la présente politique
                                            </h2>
                                            <p>
                                                {t("politique-conf.description13.description-1")}
                                                <br /><br />
                                                {t("politique-conf.description13.description-2")}
                                                <br /><br />
                                                {t("politique-conf.description13.description-3")}
                                            </p>
                                            <DownloadPDF />
                                        </section>

                                    </div>
                                </div>
                            </motion.main>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export function DownloadPDF({ buttonStyle, label = null }) {
    const { t } = useTranslation("translations")

    const defaultButtonStyle = {
        backgroundColor: '#008080',
        color: '#fff',
        border: 'none',
        borderRadius: '0.7rem',
        padding: '0.5rem 0.7rem',
        cursor: 'pointer',
        fontSize: '0.7rem',
        transition: 'backgroundColor 0.3s ease',
        marginTop: '15px',
        fontFamily: 'Typold Regular'
    }

    const buttonStyles = buttonStyle || defaultButtonStyle;

    const handleDownload = () => {
        const pdfUrl = 'https://home.izichange.com/images/izichange.pdf'; // Chemin vers votre fichier PDF
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'exercer_vos_droits_izichange.pdf'; // Nom du fichier téléchargé
        link.target = '_blank'; // Pour ouvrir le lien dans un nouvel onglet
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <span>
            <button style={buttonStyles} onClick={handleDownload}>{label ?? t('politique-conf.download')}</button>
        </span>
    );
}

export function MentionLegales() {
    const { t } = useTranslation("translations")
    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{ padding: '1rem' }}>
                        <h2>{t("mentions.title")}</h2>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.1.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.1.description">
                                    Le Site internet (<a href="https://izichange.com/" aria-label="izichange" className="text-primary">{{ site_lien: "https://izichange.com/" }}</a>) appartient à IZICHANGE, une société par actions simplifiée (SAS) enregistrée au RCCM de la République du Bénin sous le numéro RB/ABC/21 B 4180 et dont le siège social est à Abomey-Calavi Quartier TOKPA ZOUNGO Immeuble Fondation Suzane MEDE 02 BP 348 Cotonou Bénin.<br /><br />Le Directeur de la publication est OKOUIN Babatunde Marius
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.2.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.2.description">
                                </Trans>
                            </p>

                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.3.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.3.description" >
                                    <a href="mailto:info@izichange.com" aria-label="Contact Izichange via email at info@izichange.com" rel="noreferrer" target="_blank" className="text-primary">{{ site_info_email: "info@izichange.com" }}</a>
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.4.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.4.description">
                                    Le site et les services web <a href="https://izichange.com/" aria-label="Link to Izichange website" className="text-primary">{{ site_lien: "https://izichange.com/" }}</a> sont hébergés par la société :<br /><br />Contabo GmbH.<br /><br />Aschauer Strasse 32a,81549 Munich, Germany<br /><br />site web: <a href="https://aws.amazon.com/" aria-label="https://aws.amazon.com" target="_blank" rel="noreferrer" className="text-primary">{{ hosting_lient: " https://aws.amazon.com/" }}</a>
                                </Trans>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

// Affiche une page avec la politique de cookies intégrée depuis Termly, notre fournisseur de gestion du consentement. Cela garantit que les utilisateurs voient la politique officielle et à jour sans que nous ayons à la maintenir manuellement.
export function Cookies() {
    const { t, i18n } = useTranslation("translations")
    useEffect(() => CheckAndHideFooter(), [])

    const TERMLY_COOKIE_POLICY_UUID = "6c999412-0ca6-4ce4-b359-6f81aa7dd107"
    const termlyLang = (i18n.resolvedLanguage || i18n.language || "fr").toLowerCase().startsWith("fr") ? "fr" : "en"
    const termlyCookiePolicyUrl = `https://app.termly.io/policy-viewer/policy.html?policyUUID=${TERMLY_COOKIE_POLICY_UUID}&lang=${termlyLang}`

    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{ padding: '1rem' }}>
                        <h2>{t("policy.termly-policy.page-title")}</h2>
                        <p className="mt-1rem">
                            {t("policy.termly-policy.intro")}
                        </p>

                        <div className="mt-2rem" style={{ border: '1px solid #e6e6e6', borderRadius: '0.75rem', overflow: 'hidden' }}>
                            <iframe
                                key={termlyLang}
                                title={t("policy.termly-policy.page-title")}
                                src={termlyCookiePolicyUrl}
                                style={{ width: '100%', minHeight: '85vh', border: '0' }}
                                loading="lazy"
                            />
                        </div>

                        <p className="mt-1rem">
                            {t("policy.termly-policy.fallback-text")}{' '}
                            <a href={termlyCookiePolicyUrl} target="_blank" rel="noreferrer" className="text-primary">
                                {termlyCookiePolicyUrl}
                            </a>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export function Warning() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }

    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{ padding: '1rem' }}>
                        <h2 className="">{t("warning.title")}</h2>
                        <h3 className="mt-2rem">{t("warning.subtitle")}</h3>
                        <h5 className={clx("mt-2rem", style.titleHighlited)}>{t("warning.subtitle_description")}</h5 >
                        <div className="mt-1rem">
                            <p className="mt-1rem"><Trans i18nKey={"warning.description_1"} t={t}></Trans></p>
                            <ul className="" style={ulStyle}>
                                <li style={liStyle}>{t("warning.details.1")}</li>
                                <li style={liStyle}>{t("warning.details.2")}</li>
                                <li style={liStyle}>{t("warning.details.3")}</li>
                            </ul>
                            <p className="mt-1rem"><Trans i18nKey={"warning.description_2"} t={t}></Trans></p>
                            <ul className="" style={ulStyle}>
                                <li style={liStyle}>{t("warning.details.4")}</li>
                                <li style={liStyle}>{t("warning.details.5")}</li>
                                <li style={liStyle}>{t("warning.details.6")}</li>
                                <li style={liStyle}>{t("warning.details.7")}</li>
                                <li style={liStyle}>{t("warning.details.8")}</li>
                                <li style={liStyle}>{t("warning.details.9")}</li>
                                <li style={liStyle}>{t("warning.details.10")}</li>
                                <li style={liStyle}>{t("warning.details.11")}</li>
                                <li style={liStyle}>{t("warning.details.12")}</li>
                            </ul>
                            <p className="mt-1rem"><Trans i18nKey={"warning.description_3"} t={t}></Trans></p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
